var _dec, _dec2, _dec3, _dec4, _dec5, _dec6, _dec7, _dec8, _dec9, _dec10, _class, _descriptor, _descriptor2, _descriptor3, _descriptor4, _descriptor5, _descriptor6, _descriptor7, _descriptor8, _descriptor9, _descriptor10, _class2;
function _initializerDefineProperty(e, i, r, l) { r && Object.defineProperty(e, i, { enumerable: r.enumerable, configurable: r.configurable, writable: r.writable, value: r.initializer ? r.initializer.call(l) : void 0 }); }
function _defineProperty(e, r, t) { return (r = _toPropertyKey(r)) in e ? Object.defineProperty(e, r, { value: t, enumerable: !0, configurable: !0, writable: !0 }) : e[r] = t, e; }
function _toPropertyKey(t) { var i = _toPrimitive(t, "string"); return "symbol" == typeof i ? i : i + ""; }
function _toPrimitive(t, r) { if ("object" != typeof t || !t) return t; var e = t[Symbol.toPrimitive]; if (void 0 !== e) { var i = e.call(t, r || "default"); if ("object" != typeof i) return i; throw new TypeError("@@toPrimitive must return a primitive value."); } return ("string" === r ? String : Number)(t); }
function _applyDecoratedDescriptor(i, e, r, n, l) { var a = {}; return Object.keys(n).forEach(function (i) { a[i] = n[i]; }), a.enumerable = !!a.enumerable, a.configurable = !!a.configurable, ("value" in a || a.initializer) && (a.writable = !0), a = r.slice().reverse().reduce(function (r, n) { return n(i, e, r) || r; }, a), l && void 0 !== a.initializer && (a.value = a.initializer ? a.initializer.call(l) : void 0, a.initializer = void 0), void 0 === a.initializer ? (Object.defineProperty(i, e, a), null) : a; }
function _initializerWarningHelper(r, e) { throw Error("Decorating class property failed. Please ensure that transform-class-properties is enabled and runs after the decorators transform."); }
import { attr } from '@ember-data/model';
import { fragmentArray } from 'ember-data-model-fragments/attributes';
import CatalogFragment from '@square/dashboard-items-data/models/connect/catalog-fragment';
import { CatalogModifierToggleOverrideType } from '@square/dashboard-protos/models/squareup/connect/v2/catalog/resources/enums';
let ModifierListInfo = (_dec = attr('string'), _dec2 = attr('boolean', {
  allowNull: true
}), _dec3 = attr('number'), _dec4 = attr('number'), _dec5 = attr('number'), _dec6 = attr('boolean', {
  allowNull: true
}), _dec7 = attr('string', {
  protoEnum: CatalogModifierToggleOverrideType,
  defaultValue: CatalogModifierToggleOverrideType.NOT_SET
}), _dec8 = attr('string', {
  protoEnum: CatalogModifierToggleOverrideType,
  defaultValue: CatalogModifierToggleOverrideType.NOT_SET
}), _dec9 = attr('string', {
  protoEnum: CatalogModifierToggleOverrideType,
  defaultValue: CatalogModifierToggleOverrideType.NOT_SET
}), _dec10 = fragmentArray('connect/item/modifier-override'), _class = (_class2 = class ModifierListInfo extends CatalogFragment {
  constructor(...args) {
    super(...args);
    _initializerDefineProperty(this, "modifierListId", _descriptor, this);
    _initializerDefineProperty(this, "enabled", _descriptor2, this);
    _initializerDefineProperty(this, "minSelectedModifiers", _descriptor3, this);
    _initializerDefineProperty(this, "maxSelectedModifiers", _descriptor4, this);
    _initializerDefineProperty(this, "ordinal", _descriptor5, this);
    _initializerDefineProperty(this, "hiddenFromCustomer", _descriptor6, this);
    // being deprecated
    // @ts-expect-error https://github.com/adopted-ember-addons/ember-data-model-fragments/issues/457
    _initializerDefineProperty(this, "hiddenFromCustomerOverride", _descriptor7, this);
    // @ts-expect-error https://github.com/adopted-ember-addons/ember-data-model-fragments/issues/457
    _initializerDefineProperty(this, "isConversational", _descriptor8, this);
    // @ts-expect-error https://github.com/adopted-ember-addons/ember-data-model-fragments/issues/457
    _initializerDefineProperty(this, "allowQuantities", _descriptor9, this);
    _initializerDefineProperty(this, "modifierOverrides", _descriptor10, this);
  }
  get modifierList() {
    return this.store.peekRecord('connect/modifier-list', this.modifierListId);
  }
}, _defineProperty(_class2, "_modelNameForMigration", 'connect/item/modifier-list-info'), _class2), _descriptor = _applyDecoratedDescriptor(_class.prototype, "modifierListId", [_dec], {
  configurable: true,
  enumerable: true,
  writable: true,
  initializer: null
}), _descriptor2 = _applyDecoratedDescriptor(_class.prototype, "enabled", [_dec2], {
  configurable: true,
  enumerable: true,
  writable: true,
  initializer: null
}), _descriptor3 = _applyDecoratedDescriptor(_class.prototype, "minSelectedModifiers", [_dec3], {
  configurable: true,
  enumerable: true,
  writable: true,
  initializer: null
}), _descriptor4 = _applyDecoratedDescriptor(_class.prototype, "maxSelectedModifiers", [_dec4], {
  configurable: true,
  enumerable: true,
  writable: true,
  initializer: null
}), _descriptor5 = _applyDecoratedDescriptor(_class.prototype, "ordinal", [_dec5], {
  configurable: true,
  enumerable: true,
  writable: true,
  initializer: null
}), _descriptor6 = _applyDecoratedDescriptor(_class.prototype, "hiddenFromCustomer", [_dec6], {
  configurable: true,
  enumerable: true,
  writable: true,
  initializer: null
}), _descriptor7 = _applyDecoratedDescriptor(_class.prototype, "hiddenFromCustomerOverride", [_dec7], {
  configurable: true,
  enumerable: true,
  writable: true,
  initializer: null
}), _descriptor8 = _applyDecoratedDescriptor(_class.prototype, "isConversational", [_dec8], {
  configurable: true,
  enumerable: true,
  writable: true,
  initializer: null
}), _descriptor9 = _applyDecoratedDescriptor(_class.prototype, "allowQuantities", [_dec9], {
  configurable: true,
  enumerable: true,
  writable: true,
  initializer: null
}), _descriptor10 = _applyDecoratedDescriptor(_class.prototype, "modifierOverrides", [_dec10], {
  configurable: true,
  enumerable: true,
  writable: true,
  initializer: null
}), _class);
export { ModifierListInfo as default };